module.exports = __webpack_public_path__ + "static/img/newbanner.dd8f5d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newbanner.png
// module id = 79qE
// module chunks = 0